// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aba46a11","455":"477f97cd","977":"5a8e2ece"}[chunkId] + ".chunk.js";
};